/**
 * LegacyMigration API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createMigrationJob,
  getMigrationJob,
  legacyMigrationAuth,
  listMigrationJobs,
} from "../generated/legacy-migration/legacy-migration";

import { wrapMethod } from "./utils";

export const legacyMigration = {
  /** @see legacyMigrationAuth */
  legacyMigrationAuth: wrapMethod(legacyMigrationAuth),

  /** @see createMigrationJob */
  create: wrapMethod(createMigrationJob),

  /** @see listMigrationJobs */
  listMigrationJobs: wrapMethod(listMigrationJobs),

  /** @see getMigrationJob */
  getMigrationJob: wrapMethod(getMigrationJob),
} as const;

export type LegacyMigrationApi = typeof legacyMigration;
